import styled from "styled-components";

export const Section = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.bgPage,
  borderRadius: 16,
  padding: "40px 48px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 24,
  [`@media (max-width: 600px)`]: {
    padding: "32px 20px",
  },
}));

export const Title = styled("h2")(({ theme }) => ({
  fontSize: 28,
  fontWeight: 700,
  color: theme.palette.textPrimary,
  margin: 0,
  textAlign: "center",
  [`@media (max-width: 600px)`]: {
    fontSize: 22,
  },
}));

export const CheckList = styled("div")({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "12px 48px",
  [`@media (max-width: 600px)`]: {
    gridTemplateColumns: "1fr",
    gap: 12,
  },
});

export const CheckItem = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: 10,
  fontSize: 16,
  color: theme.palette.textPrimary,
  "&::before": {
    content: '"✓"',
    color: "#2ecc71",
    fontWeight: 700,
    fontSize: 18,
    flexShrink: 0,
  },
}));

export const LogosRow = styled("div")({
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  justifyContent: "center",
  gap: 12,
});

export const AirlineLogo = styled("img")({
  height: 36,
  width: "auto",
  objectFit: "contain",
  filter: "grayscale(20%)",
  opacity: 0.85,
  transition: "opacity 0.2s, filter 0.2s",
  "&:hover": {
    opacity: 1,
    filter: "grayscale(0%)",
  },
  [`@media (max-width: 600px)`]: {
    height: 28,
  },
});

export const Button = styled("a")(({ theme }) => ({
  display: "inline-block",
  backgroundColor: theme.palette.primary,
  color: theme.palette.white,
  padding: "12px 32px",
  borderRadius: 8,
  fontSize: 16,
  fontWeight: 600,
  textDecoration: "none",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: theme.palette.primaryDark,
  },
}));
